/* eslint-disable */
/**
 * AUTO-GENERATED FILE. DO NOT EDIT.
 * Generated by scripts/generateResources.ts
 */
import { ImageSource, Sound } from "excalibur";

export const resources = {
    games: {
        helicopters: {
            actors: {
                helicopter: {
                    sfxExplode: new Sound("games/helicopters/actors/helicopter/sfx-explode.wav"),
                    sfxHuey: new Sound("games/helicopters/actors/helicopter/sfx-huey.wav"),
                    spritesheetHueyLeft300x2881x3: new ImageSource("games/helicopters/actors/helicopter/spritesheet-huey-left-300x288-1x3.png"),
                    spritesheetHueyRight300x2881x3: new ImageSource("games/helicopters/actors/helicopter/spritesheet-huey-right-300x288-1x3.png"),
                    spritesheetPilot32x642x1: new ImageSource("games/helicopters/actors/helicopter/spritesheet-pilot-32x64-2x1.png"),
                },
            },
            scenes: {
                menu: {
                    spriteBackground: new ImageSource("games/helicopters/scenes/menu/sprite-background.png"),
                    spriteDistance: new ImageSource("games/helicopters/scenes/menu/sprite-distance.png"),
                    spriteForeground: new ImageSource("games/helicopters/scenes/menu/sprite-foreground.png"),
                    spriteHelicopters: new ImageSource("games/helicopters/scenes/menu/sprite-helicopters.png"),
                    spriteSky: new ImageSource("games/helicopters/scenes/menu/sprite-sky.png"),
                },
                splash: {
                    bgPilots: new ImageSource("games/helicopters/scenes/splash/bg-pilots.jpg"),
                    bgShrapnel: new ImageSource("games/helicopters/scenes/splash/bg-shrapnel.jpg"),
                    bgSunset: new ImageSource("games/helicopters/scenes/splash/bg-sunset.jpg"),
                    musicFullAutomatic: new Sound("games/helicopters/scenes/splash/music-full-automatic.mp3"),
                    musicHeavyGunner: new Sound("games/helicopters/scenes/splash/music-heavy-gunner.mp3"),
                    musicRotorBlades: new Sound("games/helicopters/scenes/splash/music-rotor-blades.mp3"),
                },
            },
        },
        skyline: {
            icon: new ImageSource("games/skyline/icon.png"),
            music: {
                dingo: new Sound("games/skyline/music/dingo.mp3"),
                fallingAwake: new Sound("games/skyline/music/falling-awake.mp3"),
                juno: new Sound("games/skyline/music/juno.mp3"),
                lifeCycles: new Sound("games/skyline/music/life-cycles.mp3"),
                magnus: new Sound("games/skyline/music/magnus.mp3"),
                palmDriveDisaster: new Sound("games/skyline/music/palm-drive-disaster.mp3"),
                phreakout21: new Sound("games/skyline/music/phreakout-21.mp3"),
                speedhound: new Sound("games/skyline/music/speedhound.mp3"),
                thisWideWorld: new Sound("games/skyline/music/this-wide-world.mp3"),
                twizzlesticks: new Sound("games/skyline/music/twizzlesticks.mp3"),
                woggle: new Sound("games/skyline/music/woggle.mp3"),
            },
            sfx: {
                crowd: new Sound("games/skyline/sfx/crowd.mp3"),
            },
            socials: new ImageSource("games/skyline/socials.png"),
        },
    },
    web: {
        socials: new ImageSource("web/socials.jpg"),
    },
} as const;
